module.exports = "/_next/static/bg_profile_large.png";